import { request } from './adminImportApi';

// The support-admin record import endpoints for one studio: what it already
// has of a type, saving a batch, and undoing a run. `runId` names one import
// run; the server only undoes rows that run created.
export function recordImportApi(userId) {
  const records = (type) =>
    `/accounts/${encodeURIComponent(userId)}/records/${encodeURIComponent(type)}`;
  return {
    load: (type) => request(records(type)),
    save: (type, runId, batch) =>
      request(records(type), { method: 'POST', body: { runId, records: batch } }),
    undo: (type, runId, ids) =>
      request(`${records(type)}/undo`, { method: 'POST', body: { runId, ids } }),
  };
}

// What each import needs to know about the studio before its review is built.
export const CONTEXT_TYPES = {
  customers: ['customers'],
  vendors: ['vendors'],
  taxLocations: ['taxLocations'],
  projects: ['customers', 'projects', 'taxLocations'],
  rooms: ['projects', 'rooms'],
  proposals: ['projects', 'proposals', 'taxLocations'],
  timeEntries: ['projects', 'timeEntries'],
};
